import { Fragment, ReactNode, useRef } from 'react';
import { useShell } from '@/providers';
import {
  Collapse,
  NavButtonLink,
  NavButtonLinkProps,
  Stack,
} from '@/primitives';
import ShellSubNavItems from './ShellSubNavItems';
import { ClickAwayListener, Popover } from '@mui/material';

export type NavItem = NavButtonLinkProps & {
  expanded?: boolean;
  label: ReactNode;
  subnavs?: NavItem[];
};

interface Props {
  items: NavItem[];
}

export default function ShellNavItems({ items }: Props) {
  const anchorRef = useRef<HTMLDivElement>(null);
  const { configMenuOpen, sidebarExpanded, setConfigMenuOpen } = useShell();

  return (
    <Stack sx={{ '& > a': { height: '64px' } }}>
      {items.map(({ expanded, label, subnavs, ...rest }, index) => (
        <Fragment key={index}>
          <NavButtonLink key={index} {...rest}>
            {sidebarExpanded && label}
          </NavButtonLink>
          {subnavs?.length && (
            <>
              <div ref={anchorRef} />
              {sidebarExpanded ? (
                <Collapse easing="ease-in-out" in={expanded} timeout={100}>
                  <ShellSubNavItems items={subnavs!} />
                </Collapse>
              ) : (
                <Popover
                  anchorEl={anchorRef.current}
                  anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                  }}
                  disableRestoreFocus
                  open={configMenuOpen}
                  slotProps={{
                    paper: {
                      sx: {
                        boxShadow: 'none',
                        transform: 'translate(22px, -64px) !important',
                      },
                    },
                  }}
                  onClose={() => setConfigMenuOpen(false)}
                >
                  <ClickAwayListener
                    onClickAway={() => setConfigMenuOpen(false)}
                  >
                    <ShellSubNavItems items={subnavs!} />
                  </ClickAwayListener>
                </Popover>
              )}
            </>
          )}
        </Fragment>
      ))}
    </Stack>
  );
}
